// extracted by mini-css-extract-plugin
export default {"content_wrapper":"BeTheFirst_content_wrapper__1cL92","content_text":"BeTheFirst_content_text__w3970"};